import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from '../styling/Header.module.css';

function Header() {
  return (
    <header className={styles.header}>
      <h1 className={styles.h1}>Expense Tracker</h1>
      <nav className={styles.nav}>
        <ul className={styles.ul}>
          <li><NavLink to='/' className={styles.navLink}>Home</NavLink></li>
          <li><NavLink to='/budgets' className={styles.navLink}>Budgets</NavLink></li>
          <li><NavLink to='/about' className={styles.navLink}>About</NavLink></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
